export let EOffersClickAction = /*#__PURE__*/function (EOffersClickAction) {
  EOffersClickAction["fromDeveloper"] = "click_developersFlats";
  EOffersClickAction["fromAgents"] = "click_agentsFlats";
  EOffersClickAction["fromAll"] = "click_allFlats";
  return EOffersClickAction;
}({});